<script lang="ts">
    import { Col, Image, Row } from 'sveltestrap';
    import { learningData } from '../../../../Data/FAQ/FAQ';
    import { FeaturedTutorials, href } from '../../../../utils/Constant/Constant';
    import StarRating from 'svelte-star-rating';
    import Card from '../../../Core/Card.svelte';
    import Link from 'svelte-link';
    let imgPath:string = "/assets/images"
    const config = {
      emptyColor:"#fff",
      fullColor: '#24695c',
      size: 15,
    };
</script>
<Col lg="12" class="featured-tutorial">
  <div class="header-faq">
    <h5 class="mb-0">{FeaturedTutorials}</h5>
  </div>
  <Row>
    {#each learningData as elem}
      <Col xl="3" md="6" class="xl-50 box-col-6">
        <Card cardProps='features-faq product-box'>
            <div slot="contentbody" class="product-hover-img">
              <div class="faq-image product-img">
                <Image fluid src="{imgPath}/{elem.img}"/>
                <div class="product-hover">
                  <ul>
                    <li>
                      <Link href="/knowledgebase">
                        <i class="icon-link"/>
                      </Link>
                    </li> 
                    <li>
                      <Link href={href}>
                        <i class="icon-import" />
                      </Link>
                    </li> 
                  </ul> 
                </div>
              </div>
              <div class="card-body">
                <h6>{elem.title}</h6>
                <p>{elem.short_description}</p>
              </div>
            </div>
            <div slot="contentfooter"> 
              <span>{elem.date}</span>
              <span class="pull-right">  
                <StarRating rating={5} {config} />
              </span> 
            </div>
        </Card>
      </Col>
    {/each}
  </Row>
</Col>
  